import type {} from '@mui/lab/themeAugmentation';

import { ThemeOptions, createTheme } from '@mui/material/styles';
import { palette } from './configs/palette';
import { styleSheetReset } from './configs/style-reset';
import { typography } from './configs/typography';
import { overrides } from './configs/overrides';

export const themeOptions: ThemeOptions = {
    palette,
    typography,
    components: {
        MuiCssBaseline: {
            styleOverrides: styleSheetReset,
        },
        ...overrides,
    },
};

export const theme = createTheme(themeOptions);
